export default "__VITE_ASSET__PHzIUEkT__"